import { render, staticRenderFns } from "./XhCustomerAddress.vue?vue&type=template&id=7ea27fd6&scoped=true&"
import script from "./XhCustomerAddress.vue?vue&type=script&lang=js&"
export * from "./XhCustomerAddress.vue?vue&type=script&lang=js&"
import style0 from "./XhCustomerAddress.vue?vue&type=style&index=0&id=7ea27fd6&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea27fd6",
  null
  
)

component.options.__file = "XhCustomerAddress.vue"
export default component.exports